import dayjs from 'dayjs'

export function checkDate(
	date: string,
	minutesToOpen: number,
	minutesToClose: number
) {
	const currentDate = dayjs().locale('pt-br')
	const eventDate = dayjs(date).locale('pt-br')
	const text = `${eventDate.format('DD [de] MMMM, [às] HH[h]mm')}`

	const isHappening =
		eventDate.diff(currentDate, 'minutes') <= minutesToOpen &&
		eventDate.diff(currentDate, 'minutes') >= -minutesToClose

	const inThePast = eventDate.diff(currentDate, 'minutes') < -minutesToClose

	return { eventDate, inThePast, isHappening, text }
}
